'use client'

import { useTranslation } from 'react-i18next'
import styles from './LandingSocialProof.module.css'

function Laurel({ mirrored = false }) {
  return (
    <svg
      className={`${styles.laurel}${mirrored ? ` ${styles.mirrored}` : ''}`}
      width="38"
      height="76"
      viewBox="0 0 48 92"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M43 87C11 62 9 29 30 7"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <g fill="currentColor">
        <path d="M28 16C26 8 30 2 37 1c0 7-4 12-9 15Z" />
        <path d="M23 23C13 20 11 13 13 8c9 3 12 9 10 15Z" />
        <path d="M17 36C7 33 3 26 5 20c9 3 14 9 12 16Z" />
        <path d="M17 50C6 49 1 43 2 37c11 2 16 7 15 13Z" />
        <path d="M22 65C10 67 3 62 3 55c12-1 18 3 19 10Z" />
        <path d="M32 78C21 84 12 80 10 74c10-5 18-1 22 4Z" />
        <path d="M20 29C18 18 23 11 30 10c1 9-4 16-10 19Z" />
        <path d="M17 43C15 33 21 26 28 25c1 9-5 15-11 18Z" />
        <path d="M20 57C15 47 20 39 26 36c5 8 1 16-6 21Z" />
        <path d="M27 71C20 63 23 53 28 48c7 7 6 16-1 23Z" />
        <path d="M38 83C30 77 29 67 33 61c8 4 10 14 5 22Z" />
      </g>
    </svg>
  )
}

export default function LandingSocialProof() {
  const { t } = useTranslation()
  // Verified 2026-09-22: one native Firestore COUNT returned 11,184,140 documents
  // in promptchan-fe814/(default)/users (readTime 2026-09-22T12:54:48.451958Z).
  // This verified account-count snapshot needs no runtime database reads.
  return (
    <div className={styles.proof}>
      <Laurel />
      <span className={styles.label}>
        <strong>11,184,140</strong> <span>{t('landingV2_usersWorldwide')}</span>
      </span>
      <Laurel mirrored />
    </div>
  )
}
